import React, { useState, useContext, useMemo } from "react";
import * as XLSX from "xlsx";
import { GlobalContext } from "../../App";
import axios from "../../api/axios";
import { toast } from "react-toastify";
import { BsChevronRight } from "react-icons/bs";
import TopHeader from "./TopHeader";
import { FaTimes } from "react-icons/fa";
import { MaterialReactTable } from "material-react-table";
import { Box } from "@mui/material";
import ManageUserTemplate from '../../assets/templates/Manage-User-BulkUpload.xlsx'
import { useNavigate, useLocation } from "react-router-dom";
import SubHeader from "./SubHeader";
function BulkUpload() {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const [selectedFile, setSelectedFile] = useState('');
  const [excelData, setExcelData] = useState([]);
  const [duplicates, setDuplicates] = useState([]);
  const [previewMapData,setPreviewMapData] = useState([]);
  const { rolexModuleData,roles,user_id } = useContext(GlobalContext);

  const handleFileChange = ({ target: { files } }) => {
    const file = files?.[0];
  
    // Perform validation to check if the file contains required headers
    const reader = new FileReader();
    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames?.[0];
      const worksheet = workbook.Sheets[sheetName];
      const parsedExcelData = XLSX.utils.sheet_to_json(worksheet, {
        header: 1,
      });
  
      const uploadedHeaders = parsedExcelData?.[0] || [];
      const requiredHeaders = [
        "system_id",
        "name",
        "contact_number",
        "email_id",
        "company_id",
        "bu_id",
        "department_id"
      ];
  
      const missingHeaders = requiredHeaders.filter(
        (header) => !uploadedHeaders.includes(header)
      );
  
      if (missingHeaders.length > 0) {
        toast.error(
          `Uploaded file is missing the following columns: ${missingHeaders.join(
            ", "
          )}`,
          {
            position: toast.POSITION.TOP_RIGHT,
            theme: "colored",
            autoClose: 5000,
          }
        );
        // Clear the selected file and reset related states
        setSelectedFile('');
        setExcelData([]);
        setDuplicates([]);
        setPreviewMapData([]);
      } else {
        // File is valid, proceed with preview
        setSelectedFile(file);
        previewExcel(file);
      }
    };
  
    reader.readAsArrayBuffer(file);
  };

  const previewExcel = (file) => {
    const reader = new FileReader();
  
    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
  
      const sheetName = workbook.SheetNames?.[0];
      const worksheet = workbook.Sheets[sheetName];
  
      const parsedExcelData = XLSX.utils.sheet_to_json(worksheet, {
        header: 1,
      });
  
      // Remove empty rows from parsedExcelData
      const filteredExcelData = parsedExcelData.filter(row => row.length > 0 && row.some(value => value !== ""));
  
      setExcelData(filteredExcelData);

      const userMap = {
        system_id : "system_id",
        name : "name",
        contact_number : "contact_number",
        email_id : "email_id",
        company_id : "company_id",
        bu_id : "bu_id",
        department_id : "department_id"
      };
 
  				

      // Find the indices of the mapped columns
      const columnIndices = Object.values(userMap).map(header => filteredExcelData[0].indexOf(header));
  
      // Create the mapped questions
      const mappedUser = filteredExcelData.slice(1).map(row => {
        return {
          system_id: row[columnIndices[0]],
          name: row[columnIndices[1]],
          contact_number: row[columnIndices[2]],
          email_id: row[columnIndices[3]],
          company_id : row[columnIndices[4]],
          bu_id : row[columnIndices[5]],
          department_id : row[columnIndices[6]],
        };
      });
      setPreviewMapData(mappedUser);
      // const duplicatesFound = findDuplicates(mappedUser, [ "system_id", "name", "contact_number", "email_id","company_id","bu_id","department_id" ]);
      const duplicatesFound = findDuplicates(mappedUser, [ "system_id","email_id"]);
      setDuplicates(duplicatesFound);
      
    };
  
    reader.readAsArrayBuffer(file);
  };

  // const findDuplicates = (data, keyColumns) => {
  //   const seen = new Set();
  //   return data.filter(row => {
  //     const key = keyColumns.map(col => row[col]).join("|");
  //     return seen.has(key) ? true : (seen.add(key), false);
  //   });
  // };
  const findDuplicates = (data, keyColumns) => {
    const seen = new Set();
    return data.filter(row => {
      for (const col of keyColumns) {
        const key = row[col];
        if (seen.has(key)) {
          return true; 
        } else {
          seen.add(key);
        }
      }
      return false; 
    });
  };
  


  const handleUpload = () => {
    if (duplicates.length > 0) {
      toast.error("Please resolve duplicate data before uploading.", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
      return;
    }
  
    if (!selectedFile) {
      toast.error("Please Select File First!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
      return;
    } 
    else if(!(previewMapData?.length > 0)){
      toast.error("Empty Data !", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
      return;
    }
    else {
      const formData = new FormData();
      formData.append("bulkupload_doc", selectedFile);
      formData.append("user_id", user_id);
      axios
        .post("/bulkupload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            const progress = (progressEvent.loaded / progressEvent.total) * 100;
            // console.log(`Upload Progress: ${progress}%`);
          },
        })
        .then((response) => {
          if (response?.status === 202) {
            toast.error(
              response?.data?.message +
                " -> " +
                response?.data?.existingRows
                  ?.map((data) => data?.system_id)
                  ?.join(","),
              {
                position: toast.POSITION.TOP_RIGHT,
                theme: "colored",
                autoClose: 2000,
              }
            );
          } else {
              toast.success("Data is inserted successfully!", {
                position: toast.POSITION.TOP_RIGHT,
                theme: "colored",
                autoClose: 2000,
              });
            }
          setSelectedFile('');
          setExcelData([]);
          setDuplicates([]);
          setPreviewMapData([]);
        })
        .catch((error) => {
          const statusCode = error.response ? error.response.status : null;
  
          if (statusCode === 500) {
            console.log(error);
            toast.error("handleUpload : Internal Server Error !", {
              position: toast.POSITION.TOP_RIGHT,
              theme: "colored",
              autoClose: 2000,
            });
          } else if (statusCode === 404) {
            toast.error("Page Not Found !", {
              position: toast.POSITION.TOP_RIGHT,
              theme: "colored",
              autoClose: 2000,
            });
          } else {
            console.log(error);
            toast.error("No handleUpload API Response !", {
              position: toast.POSITION.TOP_RIGHT,
              theme: "colored",
              autoClose: 2000,
            });
          }
        });
    }
  };
  const prevColumns = useMemo(() => [
    {
      accessorKey: "system_id", 
      id: "system_id",
      header: "System Id",
    },
    {
      accessorKey: "name", 
      id: "name",
      header: "Name",
    },
    {
      accessorKey: "contact_number", 
      id: "contact_number",
      header: "Contact Number",
    },
    {
      accessorKey: "email_id", 
      id: "email_id",
      header: "Email Id",
    },
    {
      accessorKey: "company_id", 
      id: "company_id",
      header: "Company Id",
    },
    {
      accessorKey: "bu_id", 
      id: "bu_id",
      header: "BU Id",
    },
    {
      accessorKey: "department_id", 
      id: "department_id",
      header: "Department Id",
    },
    
  ]);
  const bulkButton = {
    href: ManageUserTemplate,
    text: 'Download Template',
  };
  return (
  <div>
    <TopHeader
        breadCrumb={
          <>
            <li className="nav-item">
              <a onClick={() => navigate("/home")} className="nav-link">
                Home <BsChevronRight />
              </a>
            </li>
            <li className="nav-item">
              <span>Bulk Upload</span>
            </li>
          </>
        }
      />

<SubHeader 
  SubHeaderTitle="Bulk Upload"
  showButton={true}
  buttonText="Download Template"
  buttonHref={ManageUserTemplate}
/> 

<div  id="bulkupload">
  <div  className="bulkUploadWrap">
      {/* <Button href={ManageUserTemplate}>Download Template</Button> */}
      
  {selectedFile ?<p>{selectedFile?.name}<FaTimes onClick={()=>(setSelectedFile(''),setExcelData([]),setDuplicates([]), setPreviewMapData([]))}/></p> : <div className="attachDocument"><input type="file" accept=".xls, .xlsx" onChange={handleFileChange} /></div> } 
  {previewMapData?.length > 0 &&
     <MaterialReactTable
         columns={prevColumns}
         data={previewMapData}
         enableFullScreenToggle={false}
         enableHiding={false}
         enableDensityToggle={false}
         enableColumnActions={false}
         enableStickyHeader={true}
         muiTableContainerProps={{ sx: { maxHeight: "35vh", minHeight: "35vh" } }}
         renderTopToolbarCustomActions={({ table }) => (
           <Box
             sx={{
               display: "flex",
               gap: "1rem",
               p: "0.5rem",
               flexWrap: "wrap",
             }}
           >
           <h3>Preview Records:</h3>
           <span>Total Records: {previewMapData?.length}</span>
           </Box>
         )}
         muiTableHeadCellProps={{
           sx: (theme) => ({
             backgroundColor: "#e3ebf7",
             color: "black",
           }),
         }}
       />
}
{duplicates.length > 0 && 
         <MaterialReactTable
         columns={prevColumns}
         data={duplicates}
         enableFullScreenToggle={false}
         enableHiding={false}
         enableDensityToggle={false}
         enableColumnActions={false}
         enableStickyHeader={true}
         muiTableContainerProps={{ sx: { maxHeight: "35vh", minHeight: "35vh" } }}
         renderTopToolbarCustomActions={({ table }) => (
           <Box
             sx={{
               display: "flex",
               gap: "1rem",
               p: "0.5rem",
               flexWrap: "wrap",
             }}
           >
           <h3>Duplicate Records:</h3>
           <span>Total Records: {duplicates?.length}</span>
           </Box>
         )}
         muiTableHeadCellProps={{
           sx: (theme) => ({
             backgroundColor: "#e3ebf7",
             color: "black",
           }),
         }}
       />
}
  {/* Upload Option Available only in Create Either Admin Access */}
     {((rolexModuleData?.find((data) => pathname === data?.description && data?.create === 1)) || roles?.find((data) => data?.role_id === 1001)) && excelData.length > 0 && 
     <div className="uploadData" style={{padding:"10px"}}>
       <button className="fltrbtn btn btn-secondary" onClick={handleUpload} disabled={duplicates.length > 0}>
         Upload
       </button>
     </div>
   }
   </div>
   </div>
   </div>
  );
}

export default BulkUpload;
